import React from 'react'
import './footer.css'
import { FiSend } from "react-icons/fi";
import { FiChevronRight } from "react-icons/fi";

const Footer = () => {
  return (
    <section className='footer fade-section'>
      <div className="videoDiv"></div>

      <div className="secContent container">
        <div id='contact' className="contactDiv">
          <div className="text">
            <small>KEEP IN TOUCH</small>
            <h2>Your private lounge is one message away.</h2>
          </div>

          <div className="inputDiv">
            <a href="https://t.me/mainhookupmanagement" className='footerTelegramBtn'>
              TELEGRAM <FiSend className='sendIcon' />
            </a>
          </div>
        </div>

        <div className="footerCard">
          <div className="footerIntro">
            <div className="logoDiv">
              <span className='footerLogo'>Hookup Lounge</span>
            </div>

            <p className="footerParagraph">
              Private escapes for slow nights, spa warmth, and discreet adult experiences.
            </p>
            <p className="footerDescription">
              Hookup Lounge brings the essentials into one private booking: lounge comfort,
              jacuzzi relaxation, buffet service, spa moments, and fantasy-ready rooms.
            </p>
          </div>

          <div className="footerLinks">
            <div className="linkGroup">
              <span className="groupTitle">Experience</span>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Services
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Inclusions
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Lounge
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Aftercare
              </li>
            </div>

            <div className="linkGroup">
              <span className="groupTitle">Connect</span>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Telegram
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Support
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Feedback
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Partners
              </li>
            </div>

            <div className="linkGroup">
              <span className="groupTitle">Legal</span>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Terms
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Privacy Policy
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                Disclaimer
              </li>
              <li className="footerList">
                <FiChevronRight className='linkIcon' />
                18+ Policy
              </li>
            </div>
          </div>

          <div className="footerDiv">
            <small>(c) 2026 Hookup Lounge - Private & Discreet - 18+ Only</small>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Footer
